import Vue from 'vue'
import Fadein from './fadein'

const fadein = new Fadein()
Vue.directive('fadein', {
  bind: fadein.add.bind(fadein),
  unbind: fadein.destroy.bind(fadein),
})
